let currentLang = (typeof localStorage !== "undefined" && localStorage.getItem("rnf_lang")) || "ar";
export const setCurrentLang = (l) => { currentLang = l; };

export function formatKWD(value, lang) {
  const n = Number(value || 0).toFixed(3);
  const L = lang || currentLang;
  return L === "ar" ? `${n} د.ك` : `KWD ${n}`;
}

export const COLOR_HEX = {
  black: "#111111",
  beige: "#D8C4A8",
  grey: "#9AA0A6",
  navy: "#1F2A44",
  mocha: "#7B5E4B",
  white: "#F5F5F0",
  green: "#3B4B3F",
  burgundy: "#5E2A34",
};

export function colorHex(c) {
  return COLOR_HEX[c] || "#cccccc";
}

export function colorLabel(v, lang = "ar") {
  if (lang === "ar") return v.color_ar || v.color;
  return v.color;
}
